import * as R from "ramda";
import axios from 'axios'

const SERVER_URL = `${process.env.VUE_APP_SERVER_URL}`;

const wriStore = {
    namespaced: true,
    state: {
        q_type_options: [
            { text: "서답형", value: "5" },
            { text: "어순배열", value: "6", disabled: false },
        ],
    },
    mutations: {},
    actions: {},

}
export default wriStore;
